import AbstractApiService from 'src/services/abstractApiService';
import { getAuthorizationToken } from 'src/pages/APIs';
import { getOrgId } from 'src/utils/organization/org_id_helper';

export default class DocNetBaseService extends AbstractApiService {
  public constructor() {
    super({});
  }

  protected async getHeaders(): Promise<Record<string, string>> {
    const token = await getAuthorizationToken();
    return {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: token,
      'X-Org-ID': getOrgId(),
    };
  }
}
